import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    customFieldGroups: {
      selectIds: [],
      filters: {},
      selectId: false
    }
  },
  mutations: {
    SET_CUSTOM_FIELD_GROUP_SELECT_IDS (store, ids) {
      store.customFieldGroups.selectIds = ids
    },
    REMOVE_CUSTOM_FIELD_GROUP_SELECT_IDS (store, ids) {
      store.customFieldGroups.selectIds = store.customFieldGroups.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_CUSTOM_FIELD_GROUP_SELECT_ID (store, id) {
      store.customFieldGroups.selectId = id
    },
    SET_CUSTOM_FIELD_GROUP_FILTERS (store, filters) {
      store.customFieldGroups.filters = filters
    }
  },
  getters: {
    getCustomFieldGroups: (store, getters) => {
      return store.customFieldGroups.selectIds.map((id) => {
        return getters['entities/customFieldGroups/find'](id)
      })
    },
    getCustomFieldGroupsFilters: (store, getters) => {
      return store.customFieldGroups.filters
    },
    getCustomFieldGroup: (store, getters) => {
      return getters['entities/customFieldGroups/find'](store.customFieldGroups.selectId) || {}
    }
  },
  actions: {
    /*
    selectCustomFieldGroups
    */
    selectCustomFieldGroups ({commit, dispatch, getters, state}, filters) {
      return dispatch('getCustomFieldGroups', filters)
      .then((response) => {
        commit('SET_CUSTOM_FIELD_GROUP_FILTERS', filters)
        commit('SET_CUSTOM_FIELD_GROUP_SELECT_IDS', response.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectCustomFieldGroups
    */
    refreshSelectCustomFieldGroups ({commit, dispatch, getters, state}) {
      return dispatch('selectCustomFieldGroups', getters.getCustomFieldGroupsFilters)
    },
    /*
    selectCustomFieldGroup
    */
    selectCustomFieldGroup ({commit, dispatch, getters, state}, id) {
      return dispatch('getCustomFieldGroupById', id)
      .then((response) => {
        commit('SET_CUSTOM_FIELD_GROUP_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getCustomFieldGroups
    */
    getCustomFieldGroups ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/custom-field-groups`, {params: filters})
      .then((response) => {
        return dispatch('entities/customFieldGroups/insert', {
          data: response.data
        })
        .then((result) => {
          return result.customFieldGroups || []
        })
      })
    },
    /*
    getCustomFieldGroupById
    */
    getCustomFieldGroupById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/custom-field-groups/${id}`)
      .then((response) => {
        return dispatch('entities/customFieldGroups/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.customFieldGroups[0]
      })
    },
    /*
    createCustomFieldGroup
    */
    createCustomFieldGroup ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/custom-field-groups`, data)
      .then((response) => {
        return dispatch('entities/customFieldGroups/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.customFieldGroups[0]
      })
    },
    /*
    updateCustomFieldGroup
    */
    updateCustomFieldGroup ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/custom-field-groups/${data._id}`, data)
      .then((response) => {
        return dispatch('entities/customFieldGroups/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.customFieldGroups[0]
      })
    },
    /*
    deleteCustomFieldGroup
    */
    deleteCustomFieldGroup ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/custom-field-groups/${id}`)
      .then((response) => {
        commit('REMOVE_CUSTOM_FIELD_GROUP_SELECT_IDS', [id])
        dispatch('entities/customFieldGroups/delete', id)
        return {}
      })
    },
    /*
    ####################
    createCustomField
    */
    createCustomField ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/custom-fields`, data)
      .then((response) => {
        return response.data
      })
    },
    /*
    updateCustomField
    */
    updateCustomField ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/custom-fields/${data._id}`, data)
      .then((response) => {
        return response.data
      })
    },
    /*
    deleteCustomField
    */
    deleteCustomField ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/custom-fields/${id}`)
      .then((response) => {
        return {}
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/CustomFieldGroup.js